import React from "react";
import { Button as AntdButton, Space } from "antd";
import { FacebookOutlined, TwitterOutlined, LinkedinOutlined, WhatsAppOutlined, ShareAltOutlined } from '@ant-design/icons';
import { Box } from "@mui/material";

function SocialShare({ selectedEvent, generateICS }) {

    const handleSocialShare = (platform) => {
        let url = `https://yourwebsite.com/events/${selectedEvent.id}`;
        let text = `${selectedEvent.event_title} - Check out this event!`;

        switch (platform) {
            case 'facebook':
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "_blank");
                break;
            case 'twitter':
                window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, "_blank");
                break;
            case 'linkedin':
                window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`, "_blank");
                break;
            case 'whatsapp':
                window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}%20${encodeURIComponent(url)}`, "_blank");
                break;
            default:
                break;
        }
    };

    return (
        <Box sx={{
            display: "flex",
            justifyContent: "center",
            gap: 1,
            alignItems: "center",
            marginBottom: 1,
            flexWrap: 'wrap',
        }}>
            {/* Share Buttons */}
            <AntdButton
                icon={<FacebookOutlined />}
                onClick={() => handleSocialShare("facebook")}
                style={{ backgroundColor: "#3b5998", color: "white", borderRadius: "8px", fontWeight: "bold", padding: "8px 16px" }}
            >
                Facebook
            </AntdButton>

            <AntdButton
                icon={<TwitterOutlined />}
                onClick={() => handleSocialShare("twitter")}
                style={{ backgroundColor: "#1DA1F2", color: "white", borderRadius: "8px", fontWeight: "bold", padding: "8px 16px" }}
            >
                Twitter
            </AntdButton>

            <AntdButton
                icon={<LinkedinOutlined />}
                onClick={() => handleSocialShare("linkedin")}
                style={{ backgroundColor: "#0077b5", color: "white", borderRadius: "8px", fontWeight: "bold", padding: "8px 16px" }}
            >
                LinkedIn
            </AntdButton>

            <AntdButton
                icon={<WhatsAppOutlined />}
                onClick={() => handleSocialShare("whatsapp")}
                style={{ backgroundColor: "#25D366", color: "white", borderRadius: "8px", fontWeight: "bold", padding: "8px 16px" }}
            >
                WhatsApp
            </AntdButton>

            {/* Save to Calendar Button */}
            <AntdButton
                icon={<ShareAltOutlined />}
                onClick={() => generateICS(selectedEvent)}
                style={{
                    backgroundColor: "#4caf50", color: "white", borderRadius: "8px", fontWeight: "bold", padding: "8px 16px"
                }}
            >
                Speichern im Kalender
            </AntdButton>
        </Box>
    );
}

export default SocialShare;